import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { RoleState } from './states'

const role: Module<RoleState, State> = {
  state: new RoleState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default role
